module.exports = __webpack_public_path__ + "img/WTMS_sword2.3154bd07.png";